export class TrackRequest {
  id: number = 0;
  jobName: string = '';
  jobId: number = 0;
  mblNo: string = '';
  bookNo: string = '';
  cntrNo: string = '';
  refNo: string = '';
  vcScac: string = '';
  vessel: string = '';
  voyage: string = '';
  requestKind: string = '';
  suntekID: string = '';
  suntekReqId: number = 0;
  tspId: string = '';
  status: string = '';
  statusDesc: string = '';
  u1Id: string = '';
  u1Date: string = '';
  u2Id: string = '';
  u2Date: string = '';
  noticeTo: string = '';
  eta: string = '';

  readonly bl:string = '';
  readonly Booking:string = '';
  readonly Container:string = '';
  

  constructor(init?: Partial<TrackRequest>) {
    this.bl = 'bl';
    this.Booking = 'booking';
    this.Container = 'container';

    Object.assign(this, init);
  }
}

export enum RequestType {
  bl = 'bl',
  Booking = 'booking',
  Container = 'container',
}